import { render } from "./DettaglioOrdine.vue?vue&type=template&id=58564ba7"
import script from "./DettaglioOrdine.vue?vue&type=script&lang=js"
export * from "./DettaglioOrdine.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__